
export default function PresentationMode({ children }) {
  return children
}
